import React from 'react'
import styles from './radioCheckButton.module.scss'

const RadioCheckButton = props => {
  const { isChecked, onClick } = props;

  return (
    <button className={`${isChecked ? styles.radioButtonChecked : styles.radioButton} `} onClick={onClick}>
      {props.children}
    </button>
  )
}

export default React.memo(RadioCheckButton)